import { StyleSheet } from 'react-native';

import { smallPaddingHorizontalBox } from '../../view-style';

export default StyleSheet.create({
  container: {
    flex: 1,
  },
  coloredSection: {
    flex: 4,
  },
  blueSection: {
    flex: 1,
    justifyContent: 'center',
  },
  graySection: {
    flex: 1,
    justifyContent: 'center',
  },
  whiteSection: {
    flex: 1,
    justifyContent: 'center',
    ...smallPaddingHorizontalBox,
  },
  title: {
    textAlign: 'center',
    marginBottom: 40,
  },
  message: {
    textAlign: 'center',
    marginTop: 40,
  },
  medalSection: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    alignItems: 'center',
    justifyContent: 'center',
  },
  medalContainer: {
    padding: 30,
    borderRadius: 140,
    borderWidth: 2,
    borderBottomWidth: 4,
  },
  completeButtonContainer: {
    width: '100%',
    maxWidth: 400,
    alignSelf: 'center',
  },
});
